import { render, staticRenderFns } from "./PriorityColorIcons.vue?vue&type=template&id=60dd139f&"
import script from "./PriorityColorIcons.vue?vue&type=script&lang=js&"
export * from "./PriorityColorIcons.vue?vue&type=script&lang=js&"
import style0 from "./PriorityColorIcons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports